import React, { useState } from 'react';

import Footer from 'components/Footer';
import Header from 'components/Header';
import Routes from 'root-routes';
import { LoggedInUserProvider } from 'context/loggedin-user-context';
import { AssistantChatProvider } from 'context/assistant-chat-context';
import AssistantChatContainer from 'features/Chat/AssistantChatContainer';
import { i18n } from './i18n';
import { I18nextProvider } from 'react-i18next';

const AppContent = () => {
	const [selectedVersion, setSelectedVersion] = useState('1');
	const [bannerHeight, setBannerHeight] = useState(50); // default

	// 70px header + banner
		const mainClass = bannerHeight === 90 ? 'main--banner-tall' : 'main--banner-normal';

		// Set CSS variable for top offset (header + banner)
		React.useEffect(() => {
			const offset = 70 + bannerHeight; // header 70px + banner
			document.body.style.setProperty('--main-top-offset', offset + 'px');
			return () => {
				document.body.style.removeProperty('--main-top-offset');
			};
		}, [bannerHeight]);

		return (
			<>
				<Header onVersionChange={setSelectedVersion} onBannerHeightChange={setBannerHeight} />
				<main className={mainClass}>
					<Routes selectedVersion={selectedVersion} />
				</main>
				<Footer />
			</>
		);
	};

const App = () => {
	return (
		<>
			<I18nextProvider i18n={i18n}>
				<LoggedInUserProvider>
					<AssistantChatProvider>
						<AppContent />
						{/* ChatSidebar rendered separately to avoid impacting main app performance */}
						<AssistantChatContainer />
					</AssistantChatProvider>
				</LoggedInUserProvider>
			</I18nextProvider>
		</>
	);
};

export default App;
